if (typeof ProductPage !== 'function') {

    class ProductPage extends HTMLElement {

        constructor() {
            super();

            this.productGallery = this.querySelector('[data-js-product-gallery]');
            this.productSlider = this.querySelector('css-slider');

            this.pickupAvailabilityCompact = this.querySelector('pickup-availability-compact');
            this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

            // Gallery thumbnails
            if (this.productSlider) {
                this.setupGalleryThumbnails();
            }

            // show cart drawer when element is added to cart
            if (!document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay') {
                this.setupAddToCartListener();
            }

            // Check for models
            const models = this.querySelectorAll('product-model');
            if (models.length > 0) {
                window.ProductModel.loadShopifyXR();
                this.xrButton = this.querySelector('.product-gallery__view-in-space');
            }

            // hide buy now button if stock disabled
            this.setupBuyNowButton();

            // update secondary price if present
            this.setupPriceElements();

            // Product variant event listener for theme specific logic
            this.setupVariantChangeListener();

            // Metafields laden, nachdem das DOM vollständig geladen ist
            window.addEventListener('load', () => {
                this.loadMetafields();
            });
        }

        setupGalleryThumbnails() {
            const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

            if (this.querySelector('.product-gallery__thumbnails .thumbnail')) {
                this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
                    if (i == 0) elm.classList.add('active');
                    elm.addEventListener('click', e => this.onThumbnailClick(e, elm, productGaleryThumbnails));
                });

                this.productSlider.addEventListener('change', e => this.thumbnailNavigationHelper(e.target.index));
                this.productSlider.addEventListener('navigation', e => this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`)));
            }

            this.productSlider.addEventListener('ready', this.setupParallax.bind(this));
        }

        onThumbnailClick(e, elm, productGaleryThumbnails) {
            if (this.productSlider.sliderEnabled) {
                this.productSlider.changeSlide(e.currentTarget.dataset.index);
            } else {
                window.scrollTo({
                    top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
                    behavior: 'smooth'
                });
                this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
            }
            this._pauseAllMedia();
            this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
            productGaleryThumbnails.scrollTo({
                left: elm.offsetLeft - 50,
                behaviour: 'smooth'
            });
        }

        setupParallax() {
            const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
            const productFigures = this.querySelectorAll('.apply-gallery-animation');
            this.productSlider.addEventListener('scroll', () => {
                const scrollX = -this.productSlider.element.scrollLeft;
                productSlides.forEach((slide, i) => {
                    const media = productFigures[i];
                    if (media) {
                        media.style.transform = `translateX(${(slide.offsetLeft + scrollX) * -1 / 3}px)`;
                    }
                });
            });
        }

        setupAddToCartListener() {
            let addToCartEnter = false;
            const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
            const productForm = this.querySelector('[data-js-product-form]');

            if (addToCartButton) {
                addToCartButton.addEventListener('keyup', e => {
                    if (e.keyCode == window.KEYCODES.RETURN) {
                        addToCartEnter = true;
                    }
                });
            }

            if (productForm) {
                productForm.addEventListener('add-to-cart', () => {
                    document.getElementById('site-cart-sidebar').show();
                    if (document.getElementById('cart-recommendations')) {
                        document.getElementById('cart-recommendations').generateRecommendations();
                    }
                    if (addToCartEnter) {
                        setTimeout(() => {
                            document.querySelector('#site-cart-sidebar [data-js-close]').focus();
                        }, 200);
                    }
                });
            }
        }

        setupBuyNowButton() {
            const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
            if (addToCartButton) {
                this.toggleBuyNowButton(addToCartButton.classList.contains('disabled'));
                const buyObserver = new MutationObserver(() => {
                    this.toggleBuyNowButton(addToCartButton.classList.contains('disabled'));
                });
                buyObserver.observe(addToCartButton, { attributes: true });
            }
        }

        toggleBuyNowButton(disabled) {
            const productForm = this.querySelector('product-form');
            if (disabled) {
                productForm.classList.add('disable-buy-button');
            } else {
                productForm.classList.remove('disable-buy-button');
            }
        }

        setupPriceElements() {
            this.priceCompact = this.querySelector('[data-js-product-price-compact]');
            this.priceExtended = this.querySelector('[data-js-product-price-extended]');

            if (this.priceCompact) {
                this.priceCompact.priceOriginal = this.priceCompact.querySelector('[data-js-product-price-original]');
                this.priceCompact.priceCompare = this.priceCompact.querySelector('[data-js-product-price-compare]');
                this.priceCompact.priceUnit = this.priceCompact.querySelector('[data-js-product-price-unit]');
            }
            if (this.priceExtended) {
                this.priceExtended.priceOriginal = this.priceExtended.querySelector('[data-js-product-price-original]');
                this.priceExtended.priceCompare = this.priceExtended.querySelector('[data-js-product-price-compare]');
                this.priceExtended.priceUnit = this.priceExtended.querySelector('[data-js-product-price-unit]');
            }
        }

        setupVariantChangeListener() {
            this.productVariants = this.querySelector('product-variants');
            if (this.productVariants) {
                this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
                setTimeout(() => {
                    this.onVariantChangeHandler({ target: this.productVariants });
                }, 10);
            }
        }

        loadMetafields() {
            const variantMetafieldElement = document.querySelector('#variant_metafield_data');
            const variantMetafieldElementNutrition = document.querySelector('#variant_metafield_nutrition');
            const variantMetafieldElementIngredients = document.querySelector('#variant_metafield_ingredients');

            this.allVariantMetafieldData = this.parseMetafields(variantMetafieldElement, 'data');
            this.allVariantMetafieldDataNutrition = this.parseMetafields(variantMetafieldElementNutrition, 'nutrition');
            this.allVariantMetafieldDataIngredients = this.parseMetafields(variantMetafieldElementIngredients, 'ingredients');

            setTimeout(() => {
                if (this.allVariantMetafieldData && this.allVariantMetafieldDataNutrition && this.allVariantMetafieldDataIngredients) {
                    this.updateVariantDetails();
                } else {
                    console.error("Metafield data is not fully loaded.");
                }
            }, 100);
        }

        parseMetafields(element, type) {
            try {
                if (element) {
                    const parsedData = JSON.parse(element.textContent);
                    console.log(`Loaded ${type} Metafield Data:`, parsedData);
                    return parsedData;
                } else {
                    console.error(`#variant_metafield_${type} element not found.`);
                    return null;
                }
            } catch (error) {
                console.error(`Error parsing ${type} JSON data:`, error);
                return null;
            }
        }

        updateVariantDetails() {
            console.log("Variant has changed.");
            const variantId = this.getVariantId();

            if (variantId) {
                this.updateDetailElement('#Variant-details', this.allVariantMetafieldData, variantId);
                this.updateDetailElement('#Variant-nutrition', this.allVariantMetafieldDataNutrition, variantId);
                this.updateDetailElement('#Variant-ingredients', this.allVariantMetafieldDataIngredients, variantId);
            } else {
                console.error("No valid variant ID found.");
            }
        }

        getVariantId() {
            return this.productVariants.currentVariant?.id?.toString() || null;
        }

        updateDetailElement(selector, data, variantId) {
            try {
                const element = document.querySelector(selector);
                if (element && data && variantId && data[variantId]) {
                    element.innerHTML = data[variantId];
                } else {
                    console.error(`No metafield record found for the current variant with ID ${variantId}. Displaying default message.`);
                    element.innerHTML = "Information not available for this variant.";
                }
            } catch (error) {
                console.error(`Error updating details for ${selector}:`, error);
            }
        }

        thumbnailNavigationHelper(index = 0) {
            this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
                elm.classList.toggle('active', i == index);
            });
        }

        onVariantChangeHandler(e) {
            const variant = e.target.currentVariant;
            if (variant) {
                this.updateImageHandling(variant);
                this.updatePickupAvailability(variant);
                this.updatePriceDetails(variant);
            } else {
                this.hidePickupAvailability();
            }

            this.updateVariantDetails();
        }

        updateImageHandling(variant) {
            if (variant.featured_media) {
                const variantImg = this.productGallery.querySelector(`.product-gallery-item[data-media-id="${variant.featured_media.id}"]`);
                if (variantImg) {
                    if (this.productGallery.classList.contains('product-gallery--slider') || (this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024)) {
                        this.productSlider.changeSlide(variantImg.dataset.index);
                    } else {
                        window.scrollTo({
                            top: variantImg.offsetTop,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        }

        updatePickupAvailability(variant) {
            if (this.pickupAvailabilityCompact?.classList.contains('active')) {
                this.querySelector('pickup-availability-compact').style.display = 'block';
                this.querySelector('pickup-availability-compact').fetchAvailability(variant.id);
            }

            if (this.pickupAvailabilityExtended?.classList.contains('active')) {
                this.querySelector('pickup-availability-extended').style.display = 'block';
                this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
            }
        }

        updatePriceDetails(variant) {
            this.updatePriceElement(this.priceCompact, variant);
            this.updatePriceElement(this.priceExtended, variant, true);
        }

        updatePriceElement(priceElement, variant, extended = false) {
            if (priceElement) {
                if (!variant) {
                    priceElement.style.display = 'none';
                    priceElement.priceOriginal.innerHTML = '';
                    priceElement.priceCompare.innerHTML = '';
                    priceElement.priceUnit.innerHTML = '';
                } else {
                    priceElement.style.display = 'block';
                    priceElement.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
                    if (variant.compare_at_price > variant.price) {
                        priceElement.priceCompare.innerHTML = extended
                            ? `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this.productVariants._formatMoney(variant.compare_at_price - variant.price, KROWN.settings.shop_money_format))}</span>`
                            : this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
                    } else {
                        priceElement.priceCompare.innerHTML = '';
                    }

                    if (variant.unit_price_measurement) {
                        priceElement.priceUnit.innerHTML =
                            `${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
                            ${(variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '')}
                            ${variant.unit_price_measurement.reference_unit}`;
                    } else {
                        priceElement.priceUnit.innerHTML = '';
                    }
                }
            }
        }

        hidePickupAvailability() {
            if (this.pickupAvailabilityCompact?.classList.contains('active')) {
                this.querySelector('pickup-availability-compact').style.display = 'none';
            }

            if (this.pickupAvailabilityExtended?.classList.contains('active')) {
                this.querySelector('pickup-availability-extended').style.display = 'none';
            }
        }

        _pauseAllMedia() {
            document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
                video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            });
            document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
                video.contentWindow.postMessage('{"method":"pause"}', '*');
            });
            document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
            document.querySelectorAll('.product-gallery product-model').forEach(model => {
                if (model.modelViewerUI)
                    model.modelViewerUI.pause();
            });
        }

        _playMedia(media) {
            switch (media.dataset.productMediaType) {
                case 'video':
                    media.querySelector('video')?.play();
                    break;
                case 'external_video-youtube':
                    media.querySelector('.js-youtube')?.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                    break;
                case 'external_video-vimeo':
                    media.querySelector('.js-vimeo')?.contentWindow.postMessage('{"method":"play"}', '*');
                    break;
            }
        }

    }

    if (typeof customElements.get('product-page') == 'undefined') {
        customElements.define('product-page', ProductPage);
    }

}
